import React, { useEffect, useRef, useState } from 'react';

import { FormControl, outlinedInputClasses } from '@mui/material';

import { SearchIcon } from '~/components/icons';
import { AdornmentIconButton, TextField } from '~/components/TextField';
import { EnterKey } from '~/keyboard';

interface ISearchBar {
  value?: string;
  placeholderText?: string;
  onSearch: (search?: string) => void;
}

export const SearchBar: React.FC<ISearchBar> = (props) => {
  const { placeholderText, value, onSearch } = props;
  const ref = useRef() as React.MutableRefObject<HTMLInputElement>;
  const [currentValue, setCurrentValue] = useState(value || '');

  const handleSubmit = () => {
    onSearch(ref.current.value);
  };

  useEffect(() => {
    setCurrentValue(value || '');
  }, [value]);

  return (
    <FormControl sx={{ width: '261px' }}>
      <TextField
        placeholder={placeholderText}
        value={currentValue}
        inputProps={{ ref }}
        onSubmit={handleSubmit}
        onChange={() => {
          setCurrentValue(ref.current.value);
        }}
        sx={{
          [`.${outlinedInputClasses.root}`]: {
            background: ({ palette }) => palette.background.paper,
          },
        }}
        InputProps={{
          endAdornment: (
            <AdornmentIconButton
              onSubmit={handleSubmit}
              Icon={SearchIcon}
            />
          ),
        }}
        onKeyDown={(e) => {
          if (e.key === EnterKey) {
            handleSubmit();
          }
        }}
      />
    </FormControl>
  );
};
